<template>
  <Button
    v-bind="$attrs"
    class="btn-action"
    v-on="$listeners">
    <slot/>
  </Button>
</template>

<script>
import Button from './Button';

export default {
  name: 'IconButton',
  components: {
    Button,
  },
};
</script>

<style lang="scss">
@import '~spectre.css/src/icons';
</style>



// WEBPACK FOOTER //
// src/components/ui/IconButton.vue